export const sendMetrik = (action) => {
    if (typeof window !== 'undefined' && typeof window.ym !== 'undefined') {
        // console.log('sendMetrik', action);
        window.ym(95579099, 'reachGoal', action);
    }
}